"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReviewSchema = void 0;
const getReviewSchema = (reviews) => {
    if (!reviews?.length)
        return {};
    const reviewsSchema = reviews?.map((review) => {
        const node = review?.node;
        return {
            author: {
                '@type': 'Person',
                name: node?.submittedBy || '',
            },
            name: node?.title || '',
            datePublished: node?.submittedAt?.slice(0, 10) || '',
            reviewBody: node?.text || '',
            reviewRating: {
                bestRating: '5',
                worstRating: '1',
                ratingValue: node?.rating || 0,
                '@type': 'Rating',
            },
            '@type': 'Review',
        };
    });
    return { review: reviewsSchema };
};
exports.getReviewSchema = getReviewSchema;
//# sourceMappingURL=reviews-schema.js.map